import { useUserDetails } from 'auth/mutations/userHooks';
import { useAtomValue } from 'jotai';
import { TabNames } from '../constants';
import { activeTabNameAtom, enabledTabsAtom } from '../store';
import { useShowAdminView } from './useAdminView';
import { useInfiniteConversationsByType } from './useInfiniteConversationsByType';

export default function useConversationsQueries() {
  const {
    userDetails: { is_owner, is_boat_manager, is_captain },
  } = useUserDetails();

  const enabledTabs = useAtomValue(enabledTabsAtom);
  const showAdminView = useShowAdminView();
  const activeTabName = useAtomValue(activeTabNameAtom);

  const ownerMessagesEnabled = is_owner || is_boat_manager;
  const captainMessagesEnabled = is_captain;
  const enableOwnerQuery = !showAdminView && ownerMessagesEnabled && activeTabName === TabNames.owner;
  const enableCaptainQuery = !showAdminView && captainMessagesEnabled && activeTabName === TabNames.captain;

  const renterQuery = useInfiniteConversationsByType(TabNames.renter, !showAdminView);
  const ownerQuery = useInfiniteConversationsByType(TabNames.owner, enableOwnerQuery);
  const captainQuery = useInfiniteConversationsByType(TabNames.captain, enableCaptainQuery);

  return {
    isAnyQueryLoading: renterQuery.isLoading || ownerQuery.isLoading || captainQuery.isLoading,
    isAnyQueryFetching: renterQuery.isFetching || ownerQuery.isFetching || captainQuery.isFetching,
    isAnyQueryFetchingNextPage:
      renterQuery.isFetchingNextPage || ownerQuery.isFetchingNextPage || captainQuery.isFetchingNextPage,

    [TabNames.renter]: {
      query: renterQuery,
      isTabEnabled: enabledTabs[TabNames.renter],
    },
    [TabNames.owner]: {
      query: ownerQuery,
      isTabEnabled: ownerMessagesEnabled && enabledTabs[TabNames.renter],
    },
    [TabNames.captain]: {
      query: captainQuery,
      isTabEnabled: captainMessagesEnabled && enabledTabs[TabNames.renter],
    },
  };
}
